import { useEffect, useState } from 'react'
import { Dropdown, Form, Nav } from 'react-bootstrap'
import Container from 'react-bootstrap/Container'
import Navbar from 'react-bootstrap/Navbar'
import { useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import SocketConfig from 'sockets'

import BORROWLAND_LOGO_SVG from '../../assets/images/borrowland_logo.svg'
import CLOSE from '../../assets/images/close.svg'
import DOWN_ARROW from '../../assets/images/down_arrow.svg'
import HAMBURGUR from '../../assets/images/hamburger.svg'
import LOGOUT from '../../assets/images/logout.svg'
import NEW_NOTIFICATION_SVG from '../../assets/images/new_notification.svg'
import NOTIFICATION from '../../assets/images/notification.svg'
import PROFILE_CIRCLE from '../../assets/images/profile-circle.svg'
import QUESTION from '../../assets/images/question.svg'
import UP_ARROW from '../../assets/images/up_arrow.svg'
import VERIFIED_NOTIFICATION from '../../assets/images/verified_notification.svg'
import HEADER_TAB_ARRAY from '../array/HeaderTabArray'
import HeaderTabCard from '../card/HeaderTabCard'
import LogoutModal from '../modal/user/LogoutModal'

import './index.css'
import { useDispatch } from 'react-redux'

import {
	getProfileAction,
	// getVerificationAction
} from '../../store/sagaActions'

const formatDate = (date, sep = '-') => {
	const d = new Date(date)
	const day = String(d.getDate()).padStart(2, '0')
	const month = String(d.getMonth() + 1).padStart(2, '0')
	const year = d.getFullYear()
	return [day, month, year].join(sep)
}

const formatTime = (date) => {
	const d = new Date(date)
	const hours = String(d.getHours()).padStart(2, '0')
	const minutes = String(d.getMinutes()).padStart(2, '0')
	return `${hours}:${minutes}`
}

const Headerbar = () => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { pathname } = useLocation()
	const [show, setShow] = useState(false)
	const [responsiveDropdown, setResponsiveDropdown] = useState(false)
	const [navShow, setNavShow] = useState(true)
	const [showLogoutModal, setShowLogoutModal] = useState(false)

	const [notificationData, setNotificationData] = useState('')
	const [profileImage, setProfileImage] = useState(PROFILE_CIRCLE)
	const [profileName, setProfileName] = useState('Loading...')

	const { userData } = useSelector((state) => state.user.userDetails)
	const { userProfileDetails } = useSelector((state) => state.user.profile)
	const role = userData?.userRole
	// const profileName = userProfileDetails?.fullName || "Loading...";

	const handleNotificationClick = () => {
		//
	}

	const handleOpenLogoutModal = () => {
		setShowLogoutModal(true)
	}
	const handleCloseLogoutModal = () => {
		setShowLogoutModal(false)
	}

	const showDropdownHandle = () => {
		if (responsiveDropdown) setResponsiveDropdown(false)
		else setResponsiveDropdown(true)
	}

	const showSidebar = () => {
		setShow(true)
		setNavShow(false)
	}
	const handleCloseLink = () => {
		setResponsiveDropdown(false)
		setShow(false)
		setNavShow(true)
	}
	useEffect(() => {
		const socket = SocketConfig()
		socket.on('connect', () => {
			socket.emit('join', { userId: userData?._id })
		})

		socket.on('notification', (data) => {
			setNotificationData(data)
		})
	}, [userData?._id])

	useEffect(() => {
		// dispatch(getVerificationAction())
		dispatch(getProfileAction())
	}, [])
	// useEffect(() => {
	// 	dispatch(getVerificationAction())
	// }, [])

	useEffect(() => {
		if (userProfileDetails) {
			const name = userProfileDetails?.fullName || 'Loading...'
			setProfileName(name)

			if (userProfileDetails?.profileImage) {
				setProfileImage(userProfileDetails.profileImage)
			} else {
				setProfileImage(PROFILE_CIRCLE)
			}
		}
	}, [userProfileDetails])

	const markAsRead = () => {
		const socket = SocketConfig()
		socket.on('connect', () => {
			socket.emit('mark-read', { userId: userData?._id })
		})
	}
	const handleTimeCalculation = (time) => {
		const createdTime = new Date(time).getTime()
		if (!createdTime || Number.isNaN(createdTime)) {
			return ''
		}

		const diffSeconds = Math.floor((Date.now() - createdTime) / 1000)
		const diffMinutes = Math.floor(diffSeconds / 60)
		const diffHRS = Math.floor(diffMinutes / 60)
		const diffDays = Math.floor(diffHRS / 24)

		if (diffSeconds < 60 && diffMinutes < 1) {
			return `${diffSeconds} sec ago`
		} else if (diffMinutes < 60 && diffDays < 1) {
			return `${diffMinutes} min ago`
		} else if (diffHRS < 24 && diffDays < 1) {
			return `${diffHRS} hrs ago`
		} else {
			return ` ${formatTime(time)}, ${formatDate(time)}`
		}
	}
	const showNotification = () => {
		return (
			<Dropdown.Menu className="notification_dropdown_box">
				<div className="d-flex align-items-center justify-content-between notification_title">
					<p className="notification_title_text">Notification</p>
					<Dropdown.Toggle className="not_close_btn">
						<img src={CLOSE} alt="close" />
					</Dropdown.Toggle>
				</div>
				{notificationData?.items?.length ? (
					notificationData?.items?.map((item) => (
						<Dropdown.Item
							className={`${!item.isRead ? 'notification_active' : ' '}`}
							key={item._id}
							onClick={markAsRead}
						>
							<div className="d-flex  position-relative  align-items-center">
								<div className="mr-3">
									<img src={VERIFIED_NOTIFICATION} alt="verified" />
								</div>
								<div className="notification_desc">
									<div className="notification_real">{item?.description}</div>
									<div className="notfication_time">
										{handleTimeCalculation(item?.createdAt)}
									</div>
								</div>
								{!item?.isRead && <div className="notifiction_live" />}
							</div>
						</Dropdown.Item>
					))
				) : (
					<Dropdown.Item>
						<div className="d-flex justify-content-center">
							{/* <div className="mr-3">
										<img
											src={VERIFIED_NOTIFICATION}
											alt="verified"
										/>
									</div> */}
							<div className="notification_desc">
								<p className="notification_real">No New Notifications!</p>
								{/* <p className="notfication_time">
											a month ago
										</p> */}
							</div>
						</div>
					</Dropdown.Item>
				)}
			</Dropdown.Menu>
		)
	}
	const SideBar = () => {
		useEffect(() => {
			if (show && responsiveDropdown) {
				// setShow(false);
				return
			}
			return () => {
				// setShow(false);
				// setNavShow(true);
				// if (responsiveDropdown) setResponsiveDropdown(false);
			}
		}, [show])

		return (
			<>
				<div className="sidebar_nav ">
					<div className="position-relartive sidebar_container">
						<div className="close_icon">
							<div
								onClick={() => {
									setShow(false)
									setNavShow(true)
									setResponsiveDropdown(false)
								}}
							>
								<img src={CLOSE} />
							</div>
						</div>
						<div className="profile_tabination_box">
							<div className="profile_tab_wrapper">
								<img
									src={profileImage}
									alt="profile-icon"
									className="fixed-size-img mr-3"
								/>
								<div className="profile_dropdown_responsive">
									<p>{profileName}</p>
									<img
										src={responsiveDropdown ? UP_ARROW : DOWN_ARROW}
										alt="arrow_click"
										className="dropdown_arrow_down"
										onClick={showDropdownHandle}
									/>
								</div>
							</div>
							{responsiveDropdown ? (
								<div className="profile_dropdown_links mt-3">
									<div className="profile_state_dropdown">
										<Link
											to="/profile/identity-verification"
											onClick={handleCloseLink}
										>
											My Profile
										</Link>
									</div>
									<div className="profile_state_dropdown">
										<Link to="/security" onClick={handleCloseLink}>
											Security
										</Link>
									</div>
									{/* <div className="profile_state_dropdown">
										<Link to="/my-loans" onClick={handleCloseLink}>
											My Loans
										</Link>
									</div> */}
									<div className="profile_state_dropdown">
										<a onClick={handleOpenLogoutModal}>Logout</a>
									</div>
								</div>
							) : null}
						</div>

						<div className="tabination_wrapper_tabs">
							{HEADER_TAB_ARRAY.filter((crr) => crr.role != role).map((i) => {
								return (
									<>
										<Link
											onClick={handleCloseLink}
											to={i.to}
											className={`tabs_section ${
												i.name === 'Help' ? 'help' : ''
											}`}
										>
											<img src={i.image} alt="icon" />
											<p className="tab_title">{i.name}</p>
										</Link>
									</>
								)
							})}
						</div>
					</div>
				</div>
				<div className="component_backdrop"></div>
			</>
		)
	}
	return (
		<>
			{/* Web header */}
			<Navbar className="p-0 header_shadow" bg="white" expand="lg" id="nav_container">
				<Container className="">
					<Navbar.Brand>
						<img
							src={BORROWLAND_LOGO_SVG}
							alt="navbar-brand"
							className="borrowland-logo"
							onClick={() => navigate('/dashboard')}
						/>
					</Navbar.Brand>
					<Navbar.Toggle aria-controls="navbarScroll" />
					<Navbar.Collapse id="navbarScroll">
						<Nav
							className="m-auto my-2 my-lg-0 navbar_custom"
							style={{ maxHeight: '100px' }}
							navbarScroll
						>
							{HEADER_TAB_ARRAY.filter((crr) => crr.role != role).map((item) => {
								return (
									<HeaderTabCard
										key={item?.key}
										linkTo={item?.to}
										linkName={item?.name}
										linkImage={item?.image}
										isActive={pathname === item?.to}
									/>
								)
							})}
						</Nav>

						<Form className="d-flex profile_box">
							<div data-tooltip="FAQ" className="down_tooltip">
								<a
									id="swap_howto"
									href="https://borrowland.io/"
									target="_blank"
									rel="noreferrer"
									className="faq_blue_text"
								>
									<img src={QUESTION} alt="question" />
								</a>
							</div>
							<Dropdown id="my_dropdown ">
								<Dropdown.Toggle className="dropdown_cmn ">
									<img
										src={
											notificationData?.unReadCount > 0
												? NEW_NOTIFICATION_SVG
												: NOTIFICATION
										}
										alt="notification"
										onClick={handleNotificationClick}
									/>
								</Dropdown.Toggle>
								{showNotification()}
							</Dropdown>
							<Dropdown id="my_dropdown" className="profile_dropdown">
								<Dropdown.Toggle>
									<img
										src={profileImage}
										alt="Profile"
										className="fixed-size-img mr-3"
									/>
									<p className="text-muted p_fs_12">{profileName}</p>
								</Dropdown.Toggle>

								<Dropdown.Menu>
									<Dropdown.Item
										onClick={() => navigate('/profile/identity-verification')}
									>
										Profile
									</Dropdown.Item>
									<Dropdown.Item onClick={() => navigate('/security')}>
										Security
									</Dropdown.Item>
									{/* <Dropdown.Item onClick={() => navigate('/my-loans')}>
										My Loans
									</Dropdown.Item> */}
									<Dropdown.Item>
										<div
											className="d-flex align-items-center justify-content-between"
											onClick={handleOpenLogoutModal}
										>
											<div> Logout</div>
											<div>
												<img src={LOGOUT} alt="logout" />
											</div>
										</div>
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</Form>
					</Navbar.Collapse>
				</Container>
			</Navbar>
			{/* Tab & Mobile header */}
			{navShow ? (
				<Navbar className="tab_nav header_shadow">
					<div className="container">
						<div className="navbar_brand_tab">
							<div className="nav_icon_brand">
								<img
									src={BORROWLAND_LOGO_SVG}
									alt="navbar-brand"
									className="borrowland-logo"
								/>
							</div>
							<div className="d-flex">
								<Dropdown id="my_dropdown " className="mr-4">
									<Dropdown.Toggle className="dropdown_cmn ">
										<img
											src={
												notificationData?.unReadCount > 0
													? NEW_NOTIFICATION_SVG
													: NOTIFICATION
											}
											alt="notification"
											onClick={handleNotificationClick}
										/>
									</Dropdown.Toggle>
									{showNotification()}
								</Dropdown>
								<img
									src={HAMBURGUR}
									alt="hamburger"
									onClick={showSidebar}
									className="curser-pointer"
								/>
							</div>
						</div>
					</div>
				</Navbar>
			) : null}

			{show ? <SideBar /> : null}
			<LogoutModal showModal={showLogoutModal} closeModal={handleCloseLogoutModal} />
		</>
	)
}

export default Headerbar
